/**
 * IMPORTS
 */
import accountsSelectors from 'src/aggregates/accounts/selectors';
import {contactTypesIdToChannel} from 'src/aggregates/customers/utils';
import {IContact} from 'src/aggregates/customers/state.d';
import {IContactCommunication} from 'src/aggregates/utils/contactcommunicationinfo.d';


/**
 * CODE
 */

/**
 * I reduce contact information to retrieve the contact communication info.
 *
 * :param contact: contact to be rendered
 *
 * :returns: reduced contact
 */
function reduceContact(contact: IContact): IContactCommunication[]
{
    // initialize array of reduced contacts
    const reduced: IContactCommunication[] = [];

    // get contact channel
    const channel = contactTypesIdToChannel.get(contact.type_id)
        .toLowerCase();

    // get all active accounts for its channel
    const activeAccounts = accountsSelectors.getAllByChannel(channel);

    // map through all active accounts
    for (const account of activeAccounts)
    {
        // store contact with communication info
        reduced.push({
            account: account.id,
            channel,
            contact: contact.id,
            displayName: contact.displayName,
            typeId: contact.type_id,
            uid: contact.value,
        });
    }


    // return reduced contacts
    return reduced;
}


/**
 * EXPORTS
 */
export {
    reduceContact,
};
